

import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ProfileUtils, useProfile } from '@brg/auth';
import { CombinedEvents } from 'shared/helpers/projectEvents';
import { SUBSCRIBE_STATUS, SUBSCRIBE_VISIBILITY_STATUS } from '../Subscribe/const';
import { DropdownListItem } from '@brg/ui';
import styled, { css } from 'styled-components';
import { Designer } from '@brg/api';
import { LayoutConst } from 'core';

export const StyledDropdownListItem = styled(DropdownListItem)<{isProfile?: boolean, isContinuumSite?: boolean}>`
    position: relative;
    font-size: 15px;
    line-height: 20px;
    height: 44px;

    ${({ isProfile }) => isProfile && css`
        background: #e7e7e7;

        &:hover {
        background: #F2F2F2;
        }`
    }
    ${({ isContinuumSite }) => isContinuumSite && css`
        background: rgb(31, 31, 31);

        &:hover {
            background: rgb(44, 44, 43);
            color: #909090;
        }`
    }

    @media(max-width: ${LayoutConst.screen.s-1}px) {
        font-size: 13px;
        line-height: 16px;
        height: 40px;
    }
`;

export interface SubscribeTooltipProps {
    identifier?: string;
    visibility?: SUBSCRIBE_VISIBILITY_STATUS;
    status?: SUBSCRIBE_STATUS;
    designer?: Designer<'Local'>;
    onCancelSubscribe?: (subscriberId: string, targetId: string, name?: string) => void,
    onUnsubscribe?: (subscriberId: string, targetId: string) => void,
    onUpdateSubVisibility?: (
        subscriberId: string, 
        targetId: string, 
        mode: SUBSCRIBE_VISIBILITY_STATUS
    ) => void,
    onEditSubscribe?: (id?: string) => void,
    onStopSubscribe?: (id: string) => void,
    onShowHideSubscribe?: (id:string) => void,
    handlers?: CombinedEvents
}


/**
 * **SubscribeTooltip** - контент всплывающего меню для подписок
 * @param props
 */
export const SubscribeTooltip: FC<SubscribeTooltipProps> = (props) => {
    const {
        identifier,
        designer, 
        onUnsubscribe,
        onCancelSubscribe,
        onEditSubscribe,
        onUpdateSubVisibility,
        onShowHideSubscribe,
        visibility,
        status,
        ...handlers 
    } = props;
    const profile = useProfile();
    const { t } = useTranslation();

    const isStopSubscribe = useMemo(() => {
        return status === SUBSCRIBE_STATUS.disable
    } , [status])

    return (
        <>
            {!!onCancelSubscribe && (
                <StyledDropdownListItem 
                    onClick={(ev: React.BaseSyntheticEvent) => {
                        ev.preventDefault();
                        ev.stopPropagation();
                        onCancelSubscribe(
                            identifier ?? '', 
                            profile?.accountId ?? '', 
                            ProfileUtils.getFullNameString(designer)
                        )
                    }}
                >
                    {t('subscription.cancel_subscribe').toLowerCase()}
                </StyledDropdownListItem>
            )}
            {!!onUnsubscribe && (
                <StyledDropdownListItem 
                    onClick={(ev: React.BaseSyntheticEvent) => {
                        ev.preventDefault();
                        ev.stopPropagation();
                        status === SUBSCRIBE_STATUS.active ? onUnsubscribe(identifier ?? '', profile?.accountId ?? '') : onEditSubscribe && onEditSubscribe(identifier)
                    }}
                >
                    {t(`subscription.${status === SUBSCRIBE_STATUS.active ? 'stop_subscribe' : 'continue_subscribe'}`).toLowerCase()}
                </StyledDropdownListItem>
            )}
            {!!onUpdateSubVisibility && !isStopSubscribe && (
                <StyledDropdownListItem 
                    onClick={(ev: React.BaseSyntheticEvent) => {
                        ev.preventDefault();
                        ev.stopPropagation();
                        onUpdateSubVisibility(
                            identifier ?? '', 
                            profile?.accountId ?? '', 
                            visibility === SUBSCRIBE_VISIBILITY_STATUS.visible ? 
                            SUBSCRIBE_VISIBILITY_STATUS.hidden : 
                            SUBSCRIBE_VISIBILITY_STATUS.visible
                        )
                    }}
                >
                    {t(`subscription.${visibility === SUBSCRIBE_VISIBILITY_STATUS.visible ? 'hide' : 'show'}_subscribe`).toLowerCase()}
                </StyledDropdownListItem>
            )}
            {!!onEditSubscribe && !isStopSubscribe && (
                <StyledDropdownListItem 
                    onClick={(ev: React.BaseSyntheticEvent) => {
                        ev.preventDefault();
                        ev.stopPropagation();
                        onEditSubscribe(identifier)
                    }}
                >
                    {t('subscription.edit_subscribe').toLowerCase()}
                </StyledDropdownListItem>
            )}
        </>
    );
};


import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ProfileUtils, useProfile } from '@brg/auth';
import { CombinedEvents } from 'shared/helpers/projectEvents';
import { SUBSCRIBE_STATUS, SUBSCRIBE_VISIBILITY_STATUS } from '../Subscribe/const';
import { DropdownListItem } from '@brg/ui';
import styled, { css } from 'styled-components';
import { Designer } from '@brg/api';
import { LayoutConst } from 'core';

export const StyledDropdownListItem = styled(DropdownListItem)<{isProfile?: boolean, isContinuumSite?: boolean}>`
    position: relative;
    font-size: 15px;
    line-height: 20px;
    height: 44px;

    ${({ isProfile }) => isProfile && css`
        background: #e7e7e7;

        &:hover {
        background: #F2F2F2;
        }`
    }
    ${({ isContinuumSite }) => isContinuumSite && css`
        background: rgb(31, 31, 31);

        &:hover {
            background: rgb(44, 44, 43);
            color: #909090;
        }`
    }

    @media(max-width: ${LayoutConst.screen.s-1}px) {
        font-size: 13px;
        line-height: 16px;
        height: 40px;
    }
`;

export interface SubscribeTooltipProps {
    identifier?: string;
    visibility?: SUBSCRIBE_VISIBILITY_STATUS;
    status?: SUBSCRIBE_STATUS;
    designer?: Designer<'Local'>;
    onCancelSubscribe?: (subscriberId: string, targetId: string, name?: string) => void,
    onUnsubscribe?: (subscriberId: string, targetId: string) => void,
    onUpdateSubVisibility?: (
        subscriberId: string, 
        targetId: string, 
        mode: SUBSCRIBE_VISIBILITY_STATUS
    ) => void,
    onEditSubscribe?: (id?: string) => void,
    onStopSubscribe?: (id: string) => void,
    onShowHideSubscribe?: (id:string) => void,
    handlers?: CombinedEvents
}


/**
 * **SubscribeTooltip** - контент всплывающего меню для подписок
 * @param props
 */
export const SubscribeTooltip: FC<SubscribeTooltipProps> = (props) => {
    const {
        identifier,
        designer, 
        onUnsubscribe,
        onCancelSubscribe,
        onEditSubscribe,
        onUpdateSubVisibility,
        onShowHideSubscribe,
        visibility,
        status,
        ...handlers 
    } = props;
    const profile = useProfile();
    const { t } = useTranslation();

    const isStopSubscribe = useMemo(() => {
        return status === SUBSCRIBE_STATUS.disable
    } , [status])

    return (
        <>
            {!!onCancelSubscribe && (
                <StyledDropdownListItem 
                    onClick={(ev: React.BaseSyntheticEvent) => {
                        ev.preventDefault();
                        ev.stopPropagation();
                        onCancelSubscribe(
                            identifier ?? '', 
                            profile?.accountId ?? '', 
                            ProfileUtils.getFullNameString(designer)
                        )
                    }}
                >
                    {t('subscription.cancel_subscribe').toLowerCase()}
                </StyledDropdownListItem>
            )}
            {!!onUnsubscribe && (
                <StyledDropdownListItem 
                    onClick={(ev: React.BaseSyntheticEvent) => {
                        ev.preventDefault();
                        ev.stopPropagation();
                        status === SUBSCRIBE_STATUS.active ? onUnsubscribe(identifier ?? '', profile?.accountId ?? '') : onEditSubscribe && onEditSubscribe(identifier)
                    }}
                >
                    {t(`subscription.${status === SUBSCRIBE_STATUS.active ? 'stop_subscribe' : 'continue_subscribe'}`).toLowerCase()}
                </StyledDropdownListItem>
            )}
            {!!onUpdateSubVisibility && !isStopSubscribe && (
                <StyledDropdownListItem 
                    onClick={(ev: React.BaseSyntheticEvent) => {
                        ev.preventDefault();
                        ev.stopPropagation();
                        onUpdateSubVisibility(
                            identifier ?? '', 
                            profile?.accountId ?? '', 
                            visibility === SUBSCRIBE_VISIBILITY_STATUS.visible ? 
                            SUBSCRIBE_VISIBILITY_STATUS.hidden : 
                            SUBSCRIBE_VISIBILITY_STATUS.visible
                        )
                    }}
                >
                    {t(`subscription.${visibility === SUBSCRIBE_VISIBILITY_STATUS.visible ? 'hide' : 'show'}_subscribe`).toLowerCase()}
                </StyledDropdownListItem>
            )}
            {!!onEditSubscribe && !isStopSubscribe && (
                <StyledDropdownListItem 
                    onClick={(ev: React.BaseSyntheticEvent) => {
                        ev.preventDefault();
                        ev.stopPropagation();
                        onEditSubscribe(identifier)
                    }}
                >
                    {t('subscription.edit_subscribe').toLowerCase()}
                </StyledDropdownListItem>
            )}
        </>
    );
};
